// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--tn7yV","body":"_9e1425b4d3--body--xgbVc","sidebar":"_9e1425b4d3--sidebar--lFOE6"};